/* sizing-page.js — /pages/sizing (VST-4689)
   Tab switching + unit/gender toggles. Pure progressive enhancement:
   every panel is server-rendered and stays in the DOM (hidden attribute
   only) so all charts and fit notes remain crawlable; a noscript style in
   the sections force-shows hidden panels when JS is unavailable.
   Re-inits on shopify:section:load so the theme editor keeps working;
   data-sizing-bound guards against double-binding. */
(function () {
  // multiple sizing sections load this same script — identical <script src>
  // tags each execute, so guard to keep listeners from stacking
  if (window.__sizingPageInit) return;
  window.__sizingPageInit = true;

  function init(root) {
    // Pill tab toggles (size charts) — click + arrow keys + roving tabindex
    root.querySelectorAll('.sizing-section [role="tablist"]:not([data-sizing-bound])').forEach(function (list) {
      list.setAttribute('data-sizing-bound', '1');
      var tabs = Array.prototype.slice.call(list.querySelectorAll('.tab'));

      function select(tab) {
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', 'false');
          t.setAttribute('tabindex', '-1');
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) p.hidden = true;
        });
        tab.setAttribute('aria-selected', 'true');
        tab.setAttribute('tabindex', '0');
        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = false;
      }

      tabs.forEach(function (tab, i) {
        tab.setAttribute('tabindex', tab.getAttribute('aria-selected') === 'true' ? '0' : '-1');
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (e) {
          var next;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (next) {
            e.preventDefault();
            select(next);
            next.focus();
          }
        });
      });
    });

    // Segmented toggles (apparel inch/cm, fit-card gender) — both sets stay
    // in the DOM for crawlability
    root.querySelectorAll('.sizing-section .unit-toggle:not([data-sizing-bound])').forEach(function (group) {
      group.setAttribute('data-sizing-bound', '1');
      var scope = group.parentElement;
      group.querySelectorAll('button[data-unit]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('button[data-unit]').forEach(function (b) {
            b.setAttribute('aria-pressed', String(b === btn));
          });
          scope.querySelectorAll('.unit-set').forEach(function (set) {
            set.hidden = set.dataset.unitSet !== btn.dataset.unit;
          });
        });
      });
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
